import GaauManagersEnum from "../enums/GaauManagersEnum";

class GaauManagerService {

    Mounted(model) {
        if (!model)
            return [];

        var newModel = [];
        var managers = GaauManagersEnum;
        for (let index = 0; index < managers.length; index++) {
            let contains = model.filter((x) => managers[index] === x).length > 0;
            newModel.push(contains ? managers[index] : null);

        }
        return newModel;
    }

}

export default new GaauManagerService();